module.exports = __webpack_public_path__ + "media/images/2dImageGray-f4807009695fbd4df66a208a6c69324d.svg";